import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Apple, Smartphone } from "lucide-react";

export const Route = createFileRoute("/app/$")({
  component: AppFallbackPage,
});

function AppFallbackPage() {
  return (
    <div className="flex min-h-svh w-full items-center justify-center bg-muted/40 p-6">
      <div className="w-full max-w-sm">
        <Card className="text-center">
          <CardHeader>
            <div className="mx-auto mb-2 flex size-16 items-center justify-center rounded-full bg-primary/10">
              <Smartphone className="size-8 text-primary" />
            </div>
            <CardTitle className="text-xl">Open in Kep App</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Download the Kep app to access this content and enjoy a seamless experience on your mobile device.
            </p>
          </CardContent>
          <CardFooter className="flex flex-col gap-3">
            <Button className="w-full" asChild>
              <a
                href="https://apps.apple.com/it/app/kepapp/id1570968525"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Apple className="size-4" />
                iPhone
              </a>
            </Button>
            <Button variant="outline" className="w-full" asChild>
              <a
                href="https://play.google.com/store/apps/details?id=com.kepitalia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Smartphone className="size-4" />
                Android
              </a>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
